import groupSettings, { mockGroupSettings } from './group-settings';

// This object is automatically added to our AppContext. Please don't use this
// file directly, use the `getExtra()` parameter in ThunkActions to allow for
// mocking in tests and Storybook.
const adminServices = {
  groupSettings,
};
export default adminServices;


type AdminAppContext = {
  // All of adminServices is mounted under the 'admin' property of AppContext so
  // they won't conflict with the rest of HelloSPA.
  admin: typeof adminServices
}
export function mockAdminServices(): AdminAppContext {
  if (process.env.NODE_ENV === 'production') { return {} as AdminAppContext; }

  return {
    admin: {
      groupSettings: mockGroupSettings(),
    },
  };
}
